import { purry } from './purry';
export function pickBy() {
    return purry(_pickBy, arguments);
}
function _pickBy(object, fn) {
    if (object == null) {
        return {};
    }
    return Object.keys(object).reduce(function (acc, key) {
        if (fn(object[key], key)) {
            acc[key] = object[key];
        }
        return acc;
    }, {});
}
